module.exports = __webpack_public_path__ + "img/switzerland-diabetes-mellitus-female.eb349680.png";